import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ImageTextureNodeTextureFragment = { __typename: 'MaterialEditorTexture', id: string, legacyId: number, textureGroupId: string, type: Types.TextureType, latestRevision?: { __typename: 'MaterialEditorTextureRevision', legacyId: number, number: number } | null, revisions: Array<{ __typename: 'TextureRevision', id: string, legacyId: number, number?: number | null }> };

export type ImageTextureNodeTextureRevisionFragment = { __typename: 'MaterialEditorTextureRevision', height: number, id: string, legacyId: number, number: number, state: Types.TextureRevisionState, thumbnailUrl?: string | null, width: number, texture?: { __typename: 'MaterialEditorTexture', id: string, legacyId: number, textureGroupId: string, type: Types.TextureType, latestRevision?: { __typename: 'MaterialEditorTextureRevision', legacyId: number, number: number } | null, revisions: Array<{ __typename: 'TextureRevision', id: string, legacyId: number, number?: number | null }> } | null };

export type ImageTextureNodeTextureQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
  materialRevisionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  textureRevisionLegacyId: Types.Scalars['Int']['input'];
}>;


export type ImageTextureNodeTextureQuery = { __typename: 'Query', materialEditorData: { __typename: 'MaterialEditorMaterial', revision?: { __typename: 'MaterialEditorMaterialRevision', textureRevision: { __typename: 'MaterialEditorTextureRevision', height: number, id: string, legacyId: number, number: number, state: Types.TextureRevisionState, thumbnailUrl?: string | null, width: number, texture?: { __typename: 'MaterialEditorTexture', id: string, legacyId: number, textureGroupId: string, type: Types.TextureType, latestRevision?: { __typename: 'MaterialEditorTextureRevision', legacyId: number, number: number } | null, revisions: Array<{ __typename: 'TextureRevision', id: string, legacyId: number, number?: number | null }> } | null } } | null } };

export const ImageTextureNodeTextureFragmentDoc = gql`
    fragment ImageTextureNodeTexture on MaterialEditorTexture {
  id
  legacyId
  latestRevision {
    legacyId
    number
  }
  revisions {
    id
    legacyId
    number
  }
  textureGroupId
  type
}
    `;
export const ImageTextureNodeTextureRevisionFragmentDoc = gql`
    fragment ImageTextureNodeTextureRevision on MaterialEditorTextureRevision {
  height
  id
  legacyId
  number
  state
  texture {
    ...ImageTextureNodeTexture
  }
  thumbnailUrl
  width
}
    `;
export const ImageTextureNodeTextureDocument = gql`
    query imageTextureNodeTexture($materialId: ID!, $materialRevisionId: ID, $textureRevisionLegacyId: Int!) {
  materialEditorData(materialId: $materialId) {
    revision(revisionId: $materialRevisionId) {
      textureRevision(legacyId: $textureRevisionLegacyId) {
        ...ImageTextureNodeTextureRevision
      }
    }
  }
}
    ${ImageTextureNodeTextureRevisionFragmentDoc}
${ImageTextureNodeTextureFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ImageTextureNodeTextureGQL extends Apollo.Query<ImageTextureNodeTextureQuery, ImageTextureNodeTextureQueryVariables> {
    override document = ImageTextureNodeTextureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }